import { word } from "@modules/core/utils/i18n"
import * as Yup from "yup"

export const requiredInput = (yup: Yup.StringSchema<string | undefined, Yup.AnyObject, undefined, "">) =>
  yup.required(word("global.form.required"))

export const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/
export const sirenRegExp = /^[0-9]{9}$/
export const dateRegExpMember = /(^0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4}$)/
